import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import * as eqpToolpathApi from '../../lib/api/eqpToolpath';
import { formatPctValue } from './eqpToolpathFormat';

const REFRESH_MS = 30000; // 모니터링 보드 - 탭(10초)보다 느리게, 운전 중 카드만
const W = 160;
const H = 107;

/**
 * 모니터링 보드 카드용 작은 공구 경로 썸네일(+ 진행률 오버레이) - RUNNING 카드에서만 쓴다
 * (EqpMonitorCard가 호출). 실패/아직 분석 전이면 조용히 아무것도 안 그린다(보드는 여러 장비를
 * 한 화면에 보여주는 용도라 장비 하나 때문에 에러를 띄우지 않는다).
 */
const EqpToolpathThumbnail = ({ eqpUuid }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [pct, setPct] = useState(null);
  const objectUrlRef = useRef(null);
  const lastLineRef = useRef(null);

  useEffect(() => {
    if (!eqpUuid) return undefined;
    let cancelled = false;

    const load = async () => {
      try {
        const progRes = await eqpToolpathApi.getToolpathProgress(eqpUuid);
        const info = eqpToolpathApi.extractProgress(progRes);
        if (cancelled) return;
        if (!info || info.fileFound === false || info.indexed === false || info.line == null) {
          return;
        }
        setPct(info.pctLength);

        if (info.line === lastLineRef.current && objectUrlRef.current) {
          return; // 같은 줄이면 이미지 다시 받을 필요 없음
        }
        const imgRes = await eqpToolpathApi.getToolpathImageBlob(eqpUuid, { w: W, h: H, v: info.line });
        if (cancelled) return;
        const url = URL.createObjectURL(imgRes.data);
        if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = url;
        lastLineRef.current = info.line;
        setImageUrl(url);
      } catch (e) {
        // 조용히 - 다음 주기에 다시
      }
    };

    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current);
      objectUrlRef.current = null;
    };
  }, [eqpUuid]);

  if (!imageUrl) return null;

  return (
    <Box
      sx={{
        position: 'relative', width: '100%', maxWidth: W, aspectRatio: `${W} / ${H}`,
        borderRadius: 1, overflow: 'hidden', bgcolor: 'grey.100',
      }}
    >
      <img
        src={imageUrl}
        alt="공구 경로"
        style={{ width: '100%', height: '100%', display: 'block', objectFit: 'contain' }}
      />
      <Box
        sx={{
          position: 'absolute', bottom: 2, right: 4, px: 0.5, borderRadius: 0.5,
          bgcolor: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: '0.65rem', lineHeight: 1.4,
        }}
      >
        {formatPctValue(pct)}
      </Box>
    </Box>
  );
};

export default EqpToolpathThumbnail;
